import { render, staticRenderFns } from "./memberClient.vue?vue&type=template&id=0ff00c5c&scoped=true&"
import script from "./memberClient.vue?vue&type=script&lang=js&"
export * from "./memberClient.vue?vue&type=script&lang=js&"
import style0 from "./memberClient.vue?vue&type=style&index=0&id=0ff00c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff00c5c",
  null
  
)

export default component.exports